<script setup>
import { useRouter } from 'vue-router';
import SimuladorModal from 'dashboard/components/widgets/conversation/SimuladorClt/SimuladorModal.vue';

// ============================================================================
// v106: SIMULADOR CLT pelo MENU lateral (pedido do Kairo 06/07).
// Reusa o SimuladorModal INTEIRO passando um chat "fake" { id: 'menu' }:
// - sender cai em {} -> ficha abre VAZIA (NAO puxa CPF do contato — desejado);
// - o cache de estado usa a chave própria 'chat-menu' (não colide com as
//   conversas reais).
// Fechar o modal volta para a tela de conversas.
// ============================================================================

const router = useRouter();
const FAKE_CHAT = { id: 'menu' };

const fechar = () => {
  router.push({ name: 'home', params: { ...router.currentRoute.value.params } });
};
</script>

<template>
  <div class="w-full h-full bg-n-background">
    <SimuladorModal :current-chat="FAKE_CHAT" @close="fechar" />
  </div>
</template>
